exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[v-cloak][data-v-112ebf6e]{display:none!important}[data-v-112ebf6e]:root{touch-action:pan-x pan-y;height:100%}pre[class*=language-].line-numbers[data-v-112ebf6e]{padding-bottom:20px}.bottom-edited-btn[data-v-112ebf6e]{width:120%}@media screen and (min-width:786px){.bottom-edited-btn[data-v-112ebf6e]{margin:auto -60px;width:unset}}", ""]);

// exports
